export default __webpack_public_path__ + "static/media/cardImg2.dc1ef4a0.svg";